function toRad(Value) {
  return (Value * Math.PI) / 180;
}

export function Distance(lon1, lat1, lon2, lat2) {
  var R = 6371;
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;

  return d;
}

export const orderStoresByGeo = ({ storeList, latitude, longitude }) => {
  return storeList
    .map((el) => ({
      ...el,
      distance: Distance(
        longitude,
        latitude,
        parseFloat(el.address.long),
        parseFloat(el.address.lat)
      )
    }))
    .sort((a, b) => a.distance - b.distance);
};

export const formatDistanceToKm = (distance) => {
  if (distance > 1) {
    const calc =
      distance.toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }) + "km";
    return calc;
  }
  return (
    (distance * 1000).toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + "m"
  );
};
